import styled, { keyframes } from 'styled-components'
import { TOP_NAV_HEIGHT } from '~/constants/config'
import { light, spacing } from '~/constants/theme'
import { desktop } from '~/styles'

export const Section = styled.div`
  background-color: ${light.gray200};
`

export const ItemWrapper = styled.div<{ bottom?: boolean }>`
  width: 100%;
  height: ${TOP_NAV_HEIGHT};
  padding: ${spacing.spacingXL};
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: ${(props) =>
    props.bottom ? `2px solid ${light.gray400}` : 'unset'};
  box-sizing: border-box;
  background-color: ${light.gray200};
`

export const StyledItemWrapper = styled(ItemWrapper)`
  padding-top: 0;
`

export const ListWrapper = styled.div`
  overflow-y: scroll;
  width: 100%;
  background-color: ${light.gray200};
  height: 100%;

  &::-webkit-scrollbar {
    width: ${desktop.scrollbar}px;
    background-color: transparent;
  }

  &::-webkit-scrollbar-track {
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: ${desktop.scrollbar}px;
    -webkit-box-shadow: inset 0px 4px 14px rgba(0, 0, 0, 0.1);
    background-color: ${light.gray300};
  }
`

export const MinHeightWrapper = styled.div`
  min-height: 0px;
`

export const MaxHeightWrapper = styled.div`
  display: flex;
  max-height: 100%;
  flex-direction: column;
`

export const FilterWrapper = styled.div`
  width: calc(100% - 40px);
  display: flex;
  justify-content: center;
  align-items: center;
  padding-right: ${spacing.spacingMD};
`

export const NotificationWrapper = styled.div`
  width: 100%;
  height: 28px;
  margin-top: -16px;
  padding: 0 20px;
  display: flex;
  align-items: center;
  background-color: ${light.gray200};
  box-sizing: border-box;
  cursor: pointer;
`

const DotExpander = keyframes`
  from {
    transform: scale3d(1, 1, 1);
  }
  50% {
    transform: scale3d(1.7, 1.7, 1.7);
  }
  to {
    transform: scale3d(1, 1, 1);
  }
`

export const DotNotifier = styled.div`
  width: 6px;
  height: 6px;
  border-radius: 5px;
  margin-right: 12px;
  background-color: ${light.primaryHover};
  animation: ${DotExpander} 3s linear;
`

export const DropdownOptionWrapper = styled.div`
  width: 100%;
  padding: 0.75rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const DropdownDetailWrapper = styled.div`
  width: calc(100% - 25px);
  > p {
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`

export const UnreadWrapper = styled.div`
  font-family: 'Inter', Helvetica, sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 10px;
  line-height: 12px;
  color: ${light.gray100};
  letter-spacing: 0.03em;
  padding: ${spacing.spacingSM} ${spacing.spacingMD};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background-color: ${light.primaryHover};
`

export const LoadingWrapper = styled.div`
  height: 100%;
`

export const Loading = styled.div`
  height: 100%;
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  background: ${light.gray300};
  color: ${light.dark600};
  user-select: none;
`
